import { Link } from "react-router";

export function PortfolioBuilderCTA() {
  return (
    <div className="my-4 flex items-center justify-between rounded-lg border border-blue-900 bg-blue-950 px-4 py-3">
      <div>
        <span className="text-sm font-medium text-blue-300">
          Not sure where to start?
        </span>
        <span className="ml-1 text-sm text-gray-400">
          Get a personalized portfolio recommendation.
        </span>
      </div>
      <Link
        to="/portfolio/build"
        className="shrink-0 rounded-lg bg-blue-600 px-4 py-1.5 text-sm font-medium text-white hover:bg-blue-500 transition-colors"
      >
        Build My Portfolio
      </Link>
    </div>
  );
}
